import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { MoreVert, Replay } from "@material-ui/icons";
import React, { useContext, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { Can } from "../Can";
import TicketOptionsMenu from "../TicketOptionsMenu";
import EditarTicketModal from "../EditarTicketModal";
import * as Yup from "yup";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    marginRight: 6,
    flex: "none",
    alignSelf: "center",
    marginLeft: "auto",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

const TicketActionButtons = ({ ticket, onClickActionsItem }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const ticketOptionsMenuOpen = Boolean(anchorEl);
  const { user } = useContext(AuthContext);
  const canReturnTicket =
    user?.profile === "admin" ||
    (ticket.userId != null && String(ticket.userId) === String(user?.id));
  const [editarTicketModalOpen, setEditarTicketModalOpen] = useState(false);
  const isMounted = useRef(true);

  const handleOpenTicketOptionsMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseTicketOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  const handleValidar = (dataTicket) => {
    const schema = Yup.object().shape({
      idPlataformaSistema: Yup.mixed().required(),
      // plataformaSistema: Yup.mixed().required(),
      idModuloFuncionalidade: Yup.mixed().required(),
      // moduloFuncionalidade: Yup.mixed().required(),
      idPessoa: Yup.mixed()
        .nullable()
        .test({
          test: (value) => {
            if (ticket.queueId && ticket.queueId === 2) return true;

            if (!value) return false;

            return true;
          },
        }),
      // pessoa: Yup.mixed().required(),
      descricao: Yup.mixed().required(),
      motivoClassificacao: Yup.mixed().required(),
      tempoInicioFim: Yup.mixed().required(),
      tempoInicioFimAjustado: Yup.mixed().required(),
      tempoReal: Yup.mixed().required(),
    });

    return schema
      .isValid(dataTicket)
      .then((isValid) => {
        if (!isValid) {
          toast.error("Para resolver preencha todos os campos do Ticket!");
          return false;
        }
        return true;
      })
      .catch(() => false);
  };

  const handleUpdateTicketStatus = async (status, userId, dataTicket) => {
    setLoading(true);
    try {
      if (status === "closed") {
        if (!(await handleValidar(dataTicket))) {
          setLoading(false);
          return;
        }
      }

      await api.put(`/tickets/${ticket.id}`, {
        status: status,
        userId: userId || null,
        ...(status === "open" && ticket.status === "pending"
          ? { ticketAction: "accept" }
          : {}),
      });

      setLoading(false);
      onClickActionsItem(status);
      if (status === "open") {
        history.push("/tickets");
        history.push(`/tickets/${ticket.id}`);
      } else {
        history.push("/tickets");
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error);
    }
  };

  const handleOpenEditarModal = (e) => {
    setEditarTicketModalOpen(true);
  };

  const handleCloseEditarTicketModal = () => {
    if (isMounted.current) {
      setEditarTicketModalOpen(false);
    }
  };

  const handleSubmitEditarTicketModal = (data) => {
    if (isMounted.current) {
      setEditarTicketModalOpen(false);
      handleUpdateTicketStatus("closed", user?.id, data);
    }
  };

  return (
    <div className={classes.actionButtons}>
      {ticket.status === "closed" && (
        <ButtonWithSpinner
          loading={loading}
          startIcon={<Replay />}
          size="small"
          onClick={(e) => handleUpdateTicketStatus("open", user?.id)}
        >
          {t("messagesList.header.buttons.reopen")}
        </ButtonWithSpinner>
      )}
      {ticket.status === "open" && (
        <>
          {canReturnTicket && (
            <ButtonWithSpinner
              loading={loading}
              startIcon={<Replay />}
              size="small"
              onClick={(e) => handleUpdateTicketStatus("pending", null)}
            >
              {t("messagesList.header.buttons.return")}
            </ButtonWithSpinner>
          )}
          <ButtonWithSpinner
            loading={loading}
            size="small"
            variant="contained"
            color="primary"
            onClick={(e) => {
              handleOpenEditarModal();
              // handleUpdateTicketStatus("closed", user?.id)
            }}
          >
            {t("messagesList.header.buttons.resolve")}
          </ButtonWithSpinner>
          <IconButton color="primary" onClick={handleOpenTicketOptionsMenu}>
            <MoreVert />
          </IconButton>
          <TicketOptionsMenu
            ticket={ticket}
            anchorEl={anchorEl}
            menuOpen={ticketOptionsMenuOpen}
            handleClose={handleCloseTicketOptionsMenu}
          />
        </>
      )}
      <Can
        role={user.profile}
        perform="drawer-admin-items:view"
        yes={() => (
          <>
            {ticket.status === "pending" && (
              <ButtonWithSpinner
                loading={loading}
                size="small"
                variant="contained"
                color="primary"
                onClick={(e) => handleUpdateTicketStatus("open", user?.id)}
              >
                {t("messagesList.header.buttons.accept")}
              </ButtonWithSpinner>
            )}
          </>
        )}
      />
      <EditarTicketModal
        modalOpen={editarTicketModalOpen}
        onClose={handleCloseEditarTicketModal}
        onSubmit={handleSubmitEditarTicketModal}
        ticketid={ticket.id}
        tituloBotaoSubmit="RESOLVER"
      />
    </div>
  );
};

export default TicketActionButtons;
